"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaymentCard = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../Icon/Icon");
var _reactBootstrap = require("react-bootstrap");
var _Button = require("../Button/Button");
var _classnames = _interopRequireDefault(require("classnames"));
var _lodash = _interopRequireDefault(require("lodash"));
var _reactTransitionGroup = require("react-transition-group");
var _payment = require("../assets/icons/payment");
var _PaymentResult = require("../PaymentResult/PaymentResult");
var _icons = require("../assets/icons");
var _PaymentCardModule = _interopRequireDefault(require("./PaymentCard.module.css"));
var _excluded = ["platform", "actionType", "logo", "color", "date", "digits", "id", "deleteHandler", "callback", "resendHandler"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var PaymentCard = function PaymentCard(_ref) {
  var platform = _ref.platform,
    actionType = _ref.actionType,
    logo = _ref.logo,
    color = _ref.color,
    date = _ref.date,
    digits = _ref.digits,
    id = _ref.id,
    deleteHandler = _ref.deleteHandler,
    callback = _ref.callback,
    resendHandler = _ref.resendHandler,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = (0, _react.useState)({
      show: false,
      resend: false
    }),
    _useState2 = _slicedToArray(_useState, 2),
    action = _useState2[0],
    setAction = _useState2[1];
  var _useState3 = (0, _react.useState)({
      show: false,
      resend: false
    }),
    _useState4 = _slicedToArray(_useState3, 2),
    deleteState = _useState4[0],
    setDeleteState = _useState4[1];
  var _useState5 = (0, _react.useState)({}),
    _useState6 = _slicedToArray(_useState5, 2),
    data = _useState6[0],
    setData = _useState6[1];
  var _useState7 = (0, _react.useState)(false),
    _useState8 = _slicedToArray(_useState7, 2),
    confirm = _useState8[0],
    setConfirm = _useState8[1];
  var _useState9 = (0, _react.useState)({}),
    _useState10 = _slicedToArray(_useState9, 2),
    error = _useState10[0],
    setError = _useState10[1];
  var _useState11 = (0, _react.useState)(),
    _useState12 = _slicedToArray(_useState11, 2),
    deleteResult = _useState12[0],
    setDeleteResult = _useState12[1];
  var actionFormRef = (0, _react.useRef)();
  var deleteFormRef = (0, _react.useRef)();
  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    if (!confirm) {
      var _e$target$amount;
      //validate amount
      if (isNaN(parseFloat((_e$target$amount = e.target.amount) === null || _e$target$amount === void 0 ? void 0 : _e$target$amount.value))) {
        setError(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            amount: 'თანხა არასწორად არის მითითებული'
          });
        });
      } else {
        //add amount to state
        setData({
          amount: e.target.amount.value
        });
      }
    } else {
      var _e$target$sms;
      //validate sms
      if (((_e$target$sms = e.target.sms) === null || _e$target$sms === void 0 ? void 0 : _e$target$sms.value.trim()) === '') {
        setError(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), {}, {
            sms: 'სმს კოდი არასწორია'
          });
        });
      } else {
        //add sms to state
        setData(_objectSpread(_objectSpread({}, data), {}, {
          sms: e.target.sms.value
        }));
      }
    }
  };
  var onDelete = function onDelete(e) {
    e.preventDefault();
    e.stopPropagation();
    var inputValue = e.target.delete.value;
    if (inputValue.trim() === '') {
      setError(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          delete: 'სმს კოდი არასწორია'
        });
      });
    } else {
      var _deleteHandler = deleteHandler({
          cardId: id,
          sms: inputValue
        }),
        err = _deleteHandler.error,
        status = _deleteHandler.status;
      if (err) {
        setError(err);
      } else {
        setError({});
        e.target.delete.value = '';
        setDeleteResult(status);
      }
    }
  };
  (0, _react.useEffect)(function () {
    if (!_lodash.default.isEmpty(data)) {
      var _callback = callback(_objectSpread({
          cardId: id
        }, data)),
        err = _callback.error,
        timeout = _callback.timeout;
      if (err) {
        setError(err);
      } else {
        setError({});
        //clear form input fields
        actionFormRef.current.reset();
        if (!data.sms) {
          setConfirm(true);
          setTimeout(function () {
            return setAction(function (prevState) {
              if (prevState.show) return {
                show: true,
                resend: true
              };
              return {
                show: false,
                resend: false
              };
            });
          }, timeout * 1000);
        }
      }
    }
  }, [data]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_PaymentCardModule.default.container, _PaymentCardModule.default[platform]),
    style: {
      backgroundColor: platform === 'web' ? '#F1F1F1' : color
    },
    onClick: function onClick() {
      setAction(function (prevState) {
        return {
          show: !prevState.show,
          resend: false
        };
      });
      setData({});
      setConfirm(false);
      setError({});
    }
    /*onMouseEnter={() => setShowAction(true)}
    onMouseLeave={() => {
      if (_.isEmpty(data)) {
        setShowAction(false);
        setError({});
      }
    }}*/
  }, /*#__PURE__*/_react.default.createElement("button", {
    className: _PaymentCardModule.default.close,
    onClick: function onClick(e) {
      e.stopPropagation();
      var newState = !deleteState.show;
      if (newState) {
        if (action.show) setAction({
          show: false,
          resend: false
        });

        //send sms request
        var _deleteHandler2 = deleteHandler({
            cardId: id
          }),
          err = _deleteHandler2.error,
          timeout = _deleteHandler2.timeout;
        if (err) {
          setError(err);
        }
        setTimeout(function () {
          return setDeleteState(function (prevState) {
            if (prevState.show) return {
              show: true,
              resend: true
            };
            return {
              show: false,
              resend: false
            };
          });
        }, timeout * 1000);
      } else {
        deleteFormRef.current.reset();
        setError({});
      }
      setDeleteState({
        show: newState,
        resend: false
      });
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    height: '1.5rem',
    width: '1.5rem',
    Icon: deleteState.show ? _icons.CloseDark : platform === 'web' ? _icons.CloseDark : _icons.CloseLight
  })), /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: deleteState.show,
    timeout: 300,
    unmountOnExit: true,
    classNames: {
      enter: _PaymentCardModule.default.enter,
      enterActive: _PaymentCardModule.default.enterActive,
      enterDone: _PaymentCardModule.default.enterDone,
      exit: _PaymentCardModule.default.exit,
      exitActive: _PaymentCardModule.default.exitActive
    },
    nodeRef: deleteFormRef
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Stack, {
    as: _reactBootstrap.Form,
    gap: 4,
    noValidate: true,
    autoComplete: 'off',
    onSubmit: onDelete,
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    className: _PaymentCardModule.default.delete,
    ref: deleteFormRef
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _PaymentCardModule.default.formGroup
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, {
    style: {
      color: error.delete ? 'var(--bs-danger)' : ''
    }
  }, !error.delete ? 'მიუთითეთ SMS კოდი' : error.delete), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      position: 'relative'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    name: 'delete',
    isInvalid: !!error.delete
  }), deleteState.resend && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'info',
    outline: true,
    type: 'button',
    onClick: function onClick() {
      setDeleteState({
        show: true,
        resend: false
      });
      var _resendHandler = resendHandler(),
        timeout = _resendHandler.timeout;
      setTimeout(function () {
        return setDeleteState(function (prevState) {
          if (prevState.show) return {
            show: true,
            resend: true
          };
          return {
            show: false,
            resend: false
          };
        });
      }, timeout * 1000);
    },
    style: {
      position: 'absolute',
      right: !error.delete ? '0.7rem' : '2.5rem',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 'fit-content',
      border: 'none',
      background: 'transparent',
      padding: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    height: '2rem',
    width: '2rem',
    type: 'vec',
    Icon: _payment.Resend,
    style: {
      backgroundColor: '#435fa0'
    }
  })))), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'secondary',
    type: 'submit'
  }, "\u10D3\u10D0\u10E1\u10E2\u10E3\u10E0\u10D8"))), deleteResult && /*#__PURE__*/_react.default.createElement("div", {
    className: _PaymentCardModule.default.result,
    onClick: function onClick(e) {
      e.stopPropagation();
      //reset state
      /*setDeleteResult(null);
      setShowDelete(false);*/
      window.location.reload();
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    height: '5.8rem',
    width: '8.1rem',
    Icon: _payment.Results[deleteResult]
  }), /*#__PURE__*/_react.default.createElement("span", null, deleteResult === 'Success' ? 'ბარათი წარმატებით წაიშალა' : 'ბარათის წაშლა ვერ მოხერხდა')), /*#__PURE__*/_react.default.createElement("div", {
    className: _PaymentCardModule.default.logo,
    style: {
      backgroundImage: "url(".concat(logo, ")")
    }
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-end'
    }
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _PaymentCardModule.default.date,
    style: {
      color: platform === 'web' ? '#828282' : '#fff',
      marginBottom: platform === 'web' ? '1rem' : 0
    }
  }, date), /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
    in: action.show,
    timeout: 300,
    unmountOnExit: true,
    classNames: {
      enter: _PaymentCardModule.default.enter,
      enterActive: _PaymentCardModule.default.enterActive,
      enterDone: _PaymentCardModule.default.enterDone,
      exit: _PaymentCardModule.default.exit,
      exitActive: _PaymentCardModule.default.exitActive
    },
    nodeRef: actionFormRef
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, {
    className: (0, _classnames.default)(_PaymentCardModule.default.action, _PaymentCardModule.default[platform]),
    noValidate: true,
    onSubmit: onSubmit,
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    ref: actionFormRef,
    autoComplete: 'off'
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 7
  }, /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !confirm ? /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _PaymentCardModule.default.formGroup
  }, !!error.amount && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, error.amount), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FloatingLabel, {
    label: 'თანხა',
    style: {
      color: !error.amount ? '#8e8e8e' : 'var(--bs-danger)'
    },
    className: _PaymentCardModule.default.floatingLabel
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    placeholder: 'თანხა',
    type: 'number',
    name: 'amount',
    isInvalid: !!error.amount,
    style: {
      borderColor: !!error.amount ? 'var(--bs-danger)' : '#fff'
    }
  }))) : /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _PaymentCardModule.default.formGroup
  }, !!error.sms && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, error.sms), /*#__PURE__*/_react.default.createElement(_reactBootstrap.FloatingLabel, {
    label: 'SMS',
    style: {
      color: !error.sms ? '#8e8e8e' : 'var(--bs-danger)'
    },
    className: _PaymentCardModule.default.floatingLabel
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    placeholder: 'SMS',
    type: 'text',
    name: 'sms',
    isInvalid: !!error.sms,
    style: {
      borderColor: !!error.sms ? 'var(--bs-danger)' : '#fff',
      paddingRight: !error.sms ? '3rem' : '4.5rem'
    }
  }), action.resend && /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'info',
    outline: true,
    type: 'button',
    onClick: function onClick() {
      setAction({
        show: true,
        resend: false
      });
      var _resendHandler2 = resendHandler(),
        timeout = _resendHandler2.timeout;
      setTimeout(function () {
        setAction(function (prevState) {
          if (prevState.show) return {
            show: true,
            resend: true
          };
          return prevState;
        });
      }, timeout * 1000);
    },
    style: {
      position: 'absolute',
      right: !error.sms || platform === 'mob' ? '0.7rem' : '2.5rem',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 'fit-content',
      border: 'none',
      background: 'transparent',
      padding: 0
    }
  }, /*#__PURE__*/_react.default.createElement(_Icon.Icon, {
    height: '2rem',
    width: '2rem',
    type: 'vec',
    Icon: _payment.Resend,
    style: {
      backgroundColor: platform === 'web' ? '#435fa0' : '#fff'
    }
  })))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    xs: 'auto',
    style: {
      display: 'flex',
      alignItems: 'flex-end'
    }
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: platform === 'mob' || actionType === 'withdraw' || confirm ? 'secondary' : 'success',
    style: (confirm || actionType === 'withdraw') && {
      backgroundColor: '#435FA0',
      borderColor: '#435FA0',
      color: '#fff'
    },
    type: 'submit'
  }, confirm ? 'დასტური' : actionType === 'deposit' ? 'შევსება' : 'გატანა')))))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Stack, {
    className: _PaymentCardModule.default.number,
    direction: 'horizontal',
    gap: 3,
    style: {
      backgroundColor: color
    }
  }, /*#__PURE__*/_react.default.createElement("div", null, "****"), /*#__PURE__*/_react.default.createElement("div", null, "****"), /*#__PURE__*/_react.default.createElement("div", null, "****"), /*#__PURE__*/_react.default.createElement("div", {
    className: _PaymentCardModule.default.visible
  }, digits)));
};
exports.PaymentCard = PaymentCard;
PaymentCard.propTypes = {
  platform: _propTypes.default.oneOf(['web', 'mob']),
  actionType: _propTypes.default.oneOf(['deposit', 'withdraw']),
  logo: _propTypes.default.string,
  color: _propTypes.default.string,
  date: _propTypes.default.string,
  digits: _propTypes.default.string,
  callback: _propTypes.default.func
};
PaymentCard.defaultProps = {
  platform: 'mob',
  actionType: 'deposit',
  logo: _payment.Bog,
  color: '#FF671B',
  date: '02/23',
  digits: '4596',
  callback: function callback(data) {
    console.log(data);
    return {
      error: null,
      status: 'Success'
    };
  }
};